import React from "react";

interface Props {
  text: string | number;
  dataTest: string;
  classes?: string;
}

export default function TextCell({ text, dataTest, classes }: Props) {
  return (
    <div
      data-test={dataTest}
      className={`text-cell double-height text-padding ${classes || ""}`}
    >
      {text}
    </div>
  );
}
